module.exports = __webpack_public_path__ + "img/figure-3.3324779b.png";